/**
 * Route for `quarterly-award-recognition`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { QuarterlyAwardRecognitionPage } from "../features/quarterly-award-recognition/QuarterlyAwardRecognitionPage";

export const quarterlyAwardRecognitionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/quarterly-award-recognition",
	component: QuarterlyAwardRecognitionPage,
});

export default quarterlyAwardRecognitionRoute;
